'use strict'

import React from 'react';

export default class Flag extends React.Component {
  render() {
    var flag=<span/>;
    if (this.props.requestedPhase!==undefined || this.props.requestedStageTransition!==undefined && this.props.requestedStageTransition!==false || this.props.recommendedProjectClosure!==undefined) {
      flag=<img src="/images/Flag_FinishGrey_22x16.gif" style={{height: 19}}/>
    } else if (this.props.requestedStageException!==undefined && this.props.requestedStageException!==false) {
      flag=<img src="/images/Flag_DarkGrey_22x16.gif" style={{height: 19}}/>
    }
    return flag;
  }
}



// WEBPACK FOOTER //
// ./views/components/Flag.jsx